import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Alert } from 'react-bootstrap';
import { FieldMetaProps } from '../../Constants/ReduxFormPropTypes';
import ProviderNameField from './ProviderNameField';
import ProviderDaysField from './ProviderDaysField';
import { normalizeProviderDays, trimLeading } from '../../Helpers/normalizers';

const ProviderFields = ({
  fields,
  meta: { error },
  fieldCount,
  nameFieldPlaceholderPrefix,
  alertTrigger,
  setAlertTrigger,
}) => {
  useEffect(() => {
    const updateFieldCount = () => {
      const { length } = fields;
      const fieldChange = fieldCount - length;
      if (fieldChange > 0) {
        [...Array(fieldChange)].map((e, i) => {
          return fields.push({
            name: `${nameFieldPlaceholderPrefix} ${length + i + 1}`,
            days: '',
          });
        });
      } else if (fieldChange < 0) {
        [...Array(Math.abs(fieldChange))].map(() => {
          return fields.pop();
        });
      }
    };
    updateFieldCount();
  }, [nameFieldPlaceholderPrefix, fieldCount, fields]);

  return (
    <>
      {fields.map((e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="form-group mb-1 d-flex" key={i}>
          <Field
            name={`${e}.name`}
            component={ProviderNameField}
            type="text"
            normalize={trimLeading}
            onBlur={() => setAlertTrigger(true)}
          />

          <Field
            name={`${e}.days`}
            component={ProviderDaysField}
            type="tel"
            placeholder="0"
            onBlur={() => setAlertTrigger(true)}
            normalize={normalizeProviderDays}
          />
        </div>
      ))}
      {error && alertTrigger && (
        <Alert variant="danger" className="mt-3">
          <i className="far fa-exclamation-circle alert__icon" />
          <div>{error}</div>
        </Alert>
      )}
    </>
  );
};

ProviderFields.propTypes = {
  fields: PropTypes.shape({
    map: PropTypes.func,
    length: PropTypes.number,
    push: PropTypes.func,
    remove: PropTypes.func,
    removeAll: PropTypes.func,
    pop: PropTypes.func,
  }).isRequired,
  fieldCount: PropTypes.number.isRequired,
  nameFieldPlaceholderPrefix: PropTypes.string.isRequired,
  meta: FieldMetaProps.isRequired,
  alertTrigger: PropTypes.bool.isRequired,
  setAlertTrigger: PropTypes.func.isRequired,
};

export default ProviderFields;
